mutation ($id: ID!, $name: String!,  $iconId: ID,  $colorId: ID, $studentIds: [ID]) {
  group_update (id: $id, group: { name: $name, iconId: $iconId, colorId: $colorId, studentIds: $studentIds }) {
    id
    name
    icon {
      id
      name
      displayName
    }
    color {
      id
      name
      displayName
    }
    students {
      id
      first
      last
      communicationCount
      mostRecentCommunication
      positivity
      gradeLevel {
        id
        order
        name
      }
    }
  }
}
